import React from 'react'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import appStore from '../../assets/imagens/appstore.png'
import googlePlay from '../../assets/imagens/googleplay.png'
import styled from 'styled-components'

const Info = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding-top: 10px;
  @media (min-width: 360px) {
    flex-direction: row;
  }
  @media (min-width: 500px) {
    display: flex;
    flex-direction: column;
  }
  @media (min-width: 1000px) {
    display: flex;
    flex-direction: row;
  }
  img {
    margin: 8px 12px 0 0;
    width: 119px;

    @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
      width: 100px;
    }
  }
`

const AppInfo = () => (
  <Info>
    <a
      href="https://apps.apple.com/br/app/tag-livros/id1582214447"
      rel="noopener noreferrer"
      target="_blank"
    >
      <img
        alt="App Store"
        src={ appStore }
      />
    </a>

    <a
      href="https://play.google.com/store/apps/details?id=br.com.taglivros.tomo.app&hl=pt_BR"
      rel="noopener noreferrer"
      target="_blank"
    >
      <img
        alt="Google Play"
        src={ googlePlay }
      />
    </a>
  </Info>
)

export default AppInfo
